const DOCUMENT = 'BOOKING_';

const actions = {
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  ENABLE_IP: DOCUMENT + 'ENABLE_IP',
  DISABLE_IP: DOCUMENT + 'DISABLE_IP',
  ACTIVATE_BACKUP: DOCUMENT + 'ACTIVATE_BACKUP',
  REMOVE_SHIFT: DOCUMENT + 'REMOVE_SHIFT',
  SHOW_POOL_MODAL: DOCUMENT + 'SHOW_POOL_MODAL',
  CLOSE_POOL_MODAL: DOCUMENT + 'CLOSE_POOL_MODAL',
  SHOW_BULK_EDIT_CHECKIN_CHECKOUT_MODAL: DOCUMENT + 'SHOW_BULK_EDIT_CHECKIN_CHECKOUT_MODAL',
  CLOSE_BULK_EDIT_CHECKIN_CHECKOUT_MODAL: DOCUMENT + 'CLOSE_BULK_EDIT_CHECKIN_CHECKOUT_MODAL',
  SHOW_ASSIGN_TALENT_TO_SHIFT_MODAL: DOCUMENT + 'SHOW_ASSIGN_TALENT_TO_SHIFT_MODAL',
  CLOSE_ASSIGN_TALENT_TO_SHIFT_MODAL: DOCUMENT + 'CLOSE_ASSIGN_TALENT_TO_SHIFT_MODAL',
  SHOW_EDIT_SHIFT_MODAL: DOCUMENT + 'SHOW_EDIT_SHIFT_MODAL',
  SHOW_UPDATE_RATINGS_MODAL: DOCUMENT + 'SHOW_UPDATE_RATINGS_MODAL',
  CLOSE_EDIT_SHIFT_MODAL: DOCUMENT + 'CLOSE_EDIT_SHIFT_MODAL',
  CLOSE_UPDATE_RATINGS_MODAL: DOCUMENT + 'CLOSE_UPDATE_RATINGS_MODAL',
  SHOW_RESOLVE_HOURS_MODAL: DOCUMENT + 'SHOW_RESOLVE_HOURS_MODAL',
  SHOW_UNDO_NCNS_MODAL: DOCUMENT + 'SHOW_UNDO_NCNS_MODAL',
  CLOSE_UNDO_NCNS_MODAL: DOCUMENT + 'CLOSE_UNDO_NCNS_MODAL',
  CLOSE_RESOLVE_HOURS_MODAL: DOCUMENT + 'CLOSE_RESOLVE_HOURS_MODAL',
  SHOW_CHANGE_TO_WORKING_MODAL: DOCUMENT + 'SHOW_CHANGE_TO_WORKING_MODAL',
  CLOSE_CHANGE_TO_WORKING_MODAL: DOCUMENT + 'CLOSE_CHANGE_TO_WORKING_MODAL',
  SHOW_REMOVE_MULTIDAY_WORKER_MODAL: DOCUMENT + 'SHOW_REMOVE_MULTIDAY_WORKER_MODAL',
  CLOSE_REMOVE_MULTIDAY_WORKER_MODAL: DOCUMENT + 'CLOSE_REMOVE_MULTIDAY_WORKER_MODAL',
  SHOW_ASSIGN_MULTIDAY_WORKER_MODAL: DOCUMENT + 'SHOW_ASSIGN_MULTIDAY_WORKER_MODAL',
  CLOSE_ASSIGN_MULTIDAY_WORKER_MODAL: DOCUMENT + 'CLOSE_ASSIGN_MULTIDAY_WORKER_MODAL',
  SEND_REQUEST: DOCUMENT + 'SEND_REQUEST',
  TOGGLE_EDIT_BOOKING_MODAL: DOCUMENT + 'TOGGLE_EDIT_BOOKING_MODAL',
  NEXT: DOCUMENT + 'NEXT',
  CANCEL: DOCUMENT + 'CANCEL',
  SAVE: DOCUMENT + 'SAVE',
  TOUCH: DOCUMENT + 'TOUCH',
  ADD: DOCUMENT + 'ADD',
  LOAD: DOCUMENT + 'LOAD',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  SEARCH_CHANGED: DOCUMENT + 'SEARCH_CHANGED',
  GET_UNLOCK_REASONS_REQUEST: DOCUMENT + 'GET_UNLOCK_REASONS_REQUEST',
  GET_UNLOCK_REASONS_SUCCESS: DOCUMENT + 'GET_UNLOCK_REASONS_SUCCESS',
  SHOW_BOOKING_UNLOCK_MODAL: DOCUMENT + 'SHOW_BOOKING_UNLOCK_MODAL',
  CLOSE_BOOKING_UNLOCK_MODAL: DOCUMENT + 'CLOSE_BOOKING_UNLOCK_MODAL',
  UNLOCK_BOOKING_REQUEST: DOCUMENT + 'UNLOCK_BOOKING_REQUEST',
  CHANGE_UNLOCK_REASON: DOCUMENT + 'CHANGE_UNLOCK_REASON',
  CHANGE_UNLOCK_DETAILS: DOCUMENT + 'CHANGE_UNLOCK_DETAILS',
  CHANGE_UNLOCK_CONFIRM: DOCUMENT + 'CHANGE_UNLOCK_CONFIRM',
  DISABLE_BOOKING_ACTIONS: DOCUMENT + 'DISABLE_BOOKING_ACTIONS',

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  add: data => ({
    type: actions.ADD,
    payload: data,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),

  saveSuccess: data => ({
    type: actions.SAVE_SUCCESS,
    payload: data,
  }),

  saveError: data => ({
    type: actions.SAVE_ERROR,
    payload: data,
  }),

  cancel: () => ({
    type: actions.CANCEL,
  }),

  enableIp: data => ({
    type: actions.ENABLE_IP,
    payload: data,
  }),

  disableIp: data => ({
    type: actions.DISABLE_IP,
    payload: data,
  }),

  activateBackup: data => ({
    type: actions.ACTIVATE_BACKUP,
    payload: data,
  }),

  removeShift: data => ({
    type: actions.REMOVE_SHIFT,
    payload: data,
  }),

  showPoolModal: data => ({
    type: actions.SHOW_POOL_MODAL,
    payload: data,
  }),

  showBulkEditCheckinCheckoutModal: data => ({
    type: actions.SHOW_BULK_EDIT_CHECKIN_CHECKOUT_MODAL,
    payload: data,
  }),

  closeBulkEditCheckinCheckoutModal: data => ({
    type: actions.CLOSE_BULK_EDIT_CHECKIN_CHECKOUT_MODAL,
    payload: data,
  }),

  closePoolModal: () => ({
    type: actions.CLOSE_POOL_MODAL,
  }),

  showAssignTalentToShiftModal: data => ({
    type: actions.SHOW_ASSIGN_TALENT_TO_SHIFT_MODAL,
    payload: data,
  }),

  closeAssignTalentToShiftModal: () => ({
    type: actions.CLOSE_ASSIGN_TALENT_TO_SHIFT_MODAL,
  }),

  showEditShiftModal: data => ({
    type: actions.SHOW_EDIT_SHIFT_MODAL,
    payload: data,
  }),

  showUpdateRatingsModal: data => ({
    type: actions.SHOW_UPDATE_RATINGS_MODAL,
    payload: data,
  }),

  closeEditShiftModal: () => ({
    type: actions.CLOSE_EDIT_SHIFT_MODAL,
  }),

  closeUpdateRatingsModal: () => ({
    type: actions.CLOSE_UPDATE_RATINGS_MODAL,
  }),

  showResolveHoursModal: data => ({
    type: actions.SHOW_RESOLVE_HOURS_MODAL,
    payload: data,
  }),

  showUndoNCNSModal: data => ({
    type: actions.SHOW_UNDO_NCNS_MODAL,
    payload: data,
  }),

  closeUndoNCNSModal: () => ({
    type: actions.CLOSE_UNDO_NCNS_MODAL,
  }),

  closeResolveHoursModal: () => ({
    type: actions.CLOSE_RESOLVE_HOURS_MODAL,
  }),

  showChangeToWorkingModal: data => ({
    type: actions.SHOW_CHANGE_TO_WORKING_MODAL,
    payload: data,
  }),

  closeChangeToWorkingModal: () => ({
    type: actions.CLOSE_CHANGE_TO_WORKING_MODAL,
  }),

  showRemoveMultidayWorkerModal: data => ({
    type: actions.SHOW_REMOVE_MULTIDAY_WORKER_MODAL,
    payload: data,
  }),

  closeRemoveMultidayWorkerModal: () => ({
    type: actions.CLOSE_REMOVE_MULTIDAY_WORKER_MODAL,
  }),

  showAssignMultidayWorkerModal: data => ({
    type: actions.SHOW_ASSIGN_MULTIDAY_WORKER_MODAL,
    payload: data,
  }),

  closeAssignMultidayWorkerModal: () => ({
    type: actions.CLOSE_ASSIGN_MULTIDAY_WORKER_MODAL,
  }),

  sendRequest: data => ({
    type: actions.SEND_REQUEST,
    payload: data,
  }),

  toggleEditBookingModal: data => ({
    type: actions.TOGGLE_EDIT_BOOKING_MODAL,
    payload: data,
  }),

  onNext: () => ({
    type: actions.NEXT,
  }),

  searchChanged: data => ({
    type: actions.SEARCH_CHANGED,
    payload: data,
  }),

  showBookingUnlockModal: data => ({
    type: actions.SHOW_BOOKING_UNLOCK_MODAL,
    payload: data,
  }),

  closeBookingUnlockModal: data => ({
    type: actions.CLOSE_BOOKING_UNLOCK_MODAL,
    payload: data,
  }),

  getUnlockReasonsRequest: data => ({
    type: actions.GET_UNLOCK_REASONS_REQUEST,
    payload: data,
  }),

  getUnlockReasonsSuccess: data => ({
    type: actions.GET_UNLOCK_REASONS_SUCCESS,
    payload: data,
  }),

  unlockBookingRequest: data => ({
    type: actions.UNLOCK_BOOKING_REQUEST,
    payload: data,
  }),

  changeUnlockReason: data => ({
    type: actions.CHANGE_UNLOCK_REASON,
    payload: data,
  }),

  changeUnlockDetails: data => ({
    type: actions.CHANGE_UNLOCK_DETAILS,
    payload: data,
  }),

  changeUnlockConfirm: data => ({
    type: actions.CHANGE_UNLOCK_CONFIRM,
    payload: data,
  }),

  disableBookingActions: data => ({
    type: actions.DISABLE_BOOKING_ACTIONS,
    payload: data,
  }),
};

export default actions;
